<template>
  <div class="m_search">
    <van-nav-bar title="" />
    <van-nav-bar
      title="搜索结果"
      left-arrow
      @click-left="onClickLeft"
      class="topTitle"
    />
    <img src="@/assets/m_bg.png" class="m_bg_img" />
    <!-- 搜索 -->
    <van-search
      class="asearch"
      v-model="value"
      shape="round"
      placeholder="请输入搜索关键词"
      @search="onSearch"
      @cancel="onCancel"
    />

    <div class="content">
      <div class="searchBOX">
        搜索结果：共<span style="color: #00589f">{{ totalItem }}</span
        >条数据
      </div>

      <!-- 列表 -->
      <van-list>
        <van-cell
          v-for="item in itemList"
          icon=""
          :key="item.BusinessID"
          :title="item.BusinessName"
          @click="entryDetail(item.BusinessID)"
        >
          <img
            class="mine_headicon"
            src="@/assets/right.svg"
            slot="right-icon"
          />
        </van-cell>
      </van-list>

      <!-- 分页 -->
      <van-pagination
        v-model="currentPage"
        :total-items="totalItem"
        :items-per-page="10"
        v-show="totalItem >= 1"
        @change="changePage"
      />
    </div>

    <div class="m_bottom">版权所有 © 2021 河南大学教务处</div>
  </div>
</template>

<script>
import { searchByKeyword } from "../../utils/api.js";

export default {
  name: "m_search",
  mounted: function () {
    console.log("从vuex中获取到的搜索内容", this.$store.state.searchCTN);
    this.value = this.$store.state.searchCTN;

    //如果搜索框中有内容的话 就去调接口
    if (this.value) {
      this.goInterface("inSearch");
    }
  },
  data() {
    return {
      //搜索框中的值
      value: "",
      list: [1, 2, 3, 4, 5, 6, 17, 8, 9, 10],
      //当前页码数
      currentPage: 1,
      //查询到的总数据数
      totalItem: 0,
      //列表要显示的所有信息
      itemList: [
        // {
        //   BusinessClass: "12",
        //   BusinessDepartment: "13",
        //   BusinessID: "1",
        //   BusinessName: "缓考申请办理流程",
        //   BusinessObject: "10",
        //   ClassID: "6",
        //   ClassName: "考试管理",
        //   Department: "13",
        //   ObjectName: "学生",
        //   SubClassName: "缓考申请",
        // },
      ],
    };
  },
  methods: {
    //van-nav-bar左侧点击返回
    onClickLeft() {
      console.log("search点击了返回,返回上一页./");
      this.$router.replace("./m_home");
    },
    //搜索框搜索时触发
    onSearch(val) {
      //   Toast(val);
      console.log(val);
      this.$store.commit("searchCTN", this.value);

      this.goInterface("inSearch");
    },
    //搜索框取消时触发
    onCancel() {
      console.log("取消");
      //   Toast("取消");
    },
    //点击列表事项进入详情页
    entryDetail: function (articleId) {
      console.log("列表页点击了,事项id是", articleId);
      // this.$router.replace("./detail");
      this.$router.replace({
        path: "./m_detail",
        name: "m_detail",
        params: {
          inRole: "search",
          articleID: articleId,
        },
      });
    },
    //废弃
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      //   setTimeout(() => {
      //     for (let i = 0; i < 10; i++) {
      //       this.list.push(this.list.length + 1);
      //     }

      //     // 加载状态结束
      //     this.loading = false;

      //     // 数据全部加载完成
      //     if (this.list.length >= 40) {
      //       this.finished = true;
      //     }
      //   }, 1000);
      console.log("1123");
    },
    //调接口统一地
    goInterface(whichType) {
      switch (whichType) {
        case "inSearch":
          searchByKeyword(this.value, this.currentPage).then((result) => {
            console.log(result);
            this.totalItem = result.totalItem;
            this.itemList = result.itemList;
          });
          break;
      }
    },
    //改变页面时触发
    changePage() {
      console.log(this.currentPage);
      this.goInterface("inSearch");
    },
  },
};
</script>

<style scoped>
.m_search {
  text-align: left;
  width: 100vw;
  height: 100vh;
  background: #fff;
  position: relative;
}

.m_search .m_bg_img {
  width: 100%;
  height: auto;
  z-index: -1;
}
.asearch {
  position: absolute;
  top: 5rem;
  width: 96%;
  margin: auto 2%;
  left: 0px;
  background: rgba(0, 0, 0, 0);
}
.m_search .van-cell {
  padding: 10px 20px;
  background: #fff;
}
.asearch van-search__content van-search__content--round {
  background: rgba(0, 0, 0, 0);
  overflow: hidden;
}
.m_search .van-search__content {
  height: 3.5rem;
  align-items: center;
}

.m_search .van-search__content .van-cell {
  background: rgba(0, 0, 0, 0);
}

.content {
  position: absolute;
  top: 10rem;
  left: 0;
  min-height: 70vh;
  width: 90%;
  margin: 0px 5%;
  background: #09c;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
  border-radius: 16px 16px 16px 16px;
  align-items: center;
  text-align: left;
}

.inBTM {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 55px;
  line-height: 55px;
  /* background-color: whitesmoke; */
  background-color: #09c;
  color: white;
  text-align: center;
  font-size: 14px;
}
.searchBOX {
  margin: 10px auto 5px 20px;
  width: 100%;
  font-size: 20px;
  line-height: 30px;
  text-align: left;
  font-weight: 500;
  color: #333333;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.content .van-list {
  margin: 10px auto;
}
.content .van-list .van-cell {
  height: 5vh;
}
.content .van-list.van-cell::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border: 1px solid #D8D8D8;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
}
.content .van-list .van-cell__title {
  font-weight: 400;
  font-size: 19px;
  color: #333333;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.topTitle {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
.content .van-pagination {
  position: absolute;
  left: 0px;
  bottom: 30px;
  width: 90%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 5%;
}
.content .van-pagination .van-pagination__item--active {
  background-color: #DFEDF9;
}
.m_bottom {
  position: absolute;
  top: 93%;
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 20px;
  color: #999999;
  line-height: 48px;
}
</style>